import React, { useCallback, useContext, useState } from 'react';

import {
  QBodyLayout,
  QButton,
  QButtonGroup,
  QCloseButton,
  QFooter,
  QHeader,
  QStep,
  QSubtitle,
  QTitle,
} from '@qualio/ui-components';

import { IntegrationContext } from '../../context/integration';
import { Integration } from '../steps/Integration';

type SelfServiceLayoutProps = {
  onClose: () => void;
  subTitle: string;
};

export const SelfServiceLayout: React.FC<SelfServiceLayoutProps> = ({ onClose, subTitle }) => {
  const [activeStep, setActiveStep] = useState(0);
  const context = useContext(IntegrationContext);

  const onPrevious = useCallback(() => setActiveStep((step) => step - 1), []);
  const onNext = useCallback(() => setActiveStep((step) => step + 1), []);

  const onStepItemClicked = useCallback((...args) => console.log('step item clicked', ...args), []);

  return (
    <QBodyLayout.SplitPanelLeftWithStepper activeStep={activeStep} onStepItemClicked={onStepItemClicked}>
      <QHeader>
        <QTitle>Setup Integration</QTitle>
        <QSubtitle>{subTitle}</QSubtitle>
        <QButtonGroup>
          <QCloseButton onClick={onClose} />
        </QButtonGroup>
      </QHeader>
      <QStep title="Select Integration" />
      <QStep title="Filter" />
      <QStep title="Mapping" />
      <QStep title="Verify" />
      <Integration />
      <p data-cy="filter-step">Filter</p>
      <p>Mapping</p>
      <p>Verify</p>
      <QFooter>
        <QButton onClick={onNext} isDisabled={!context?.formEnabled} data-cy="next-integration">
          Next
        </QButton>
      </QFooter>
      <QFooter>
        <QButton onClick={onPrevious} variant="outline">
          Previous
        </QButton>
        <QButton onClick={onNext}>Next</QButton>
      </QFooter>
      <QFooter>
        <QButton onClick={onPrevious} variant="outline">
          Previous
        </QButton>
        <QButton onClick={onNext}>Next</QButton>
      </QFooter>
      <QFooter>
        <QButton onClick={onPrevious} variant="outline">
          Previous
        </QButton>
        <QButton onClick={undefined}>Save</QButton>
      </QFooter>
    </QBodyLayout.SplitPanelLeftWithStepper>
  );
};
